import React, { useState, useEffect } from "react";
import NavHeader from "../../Common/NavHeader";
import BreadCrumb from "../../Common/BreadCrumb";
import Paginator from "../../Common/Paginator";
import {
  getLabourReport,
  changeLabourCategory,
  getAllLaborClasses,
  updateRawLabor,
  addNewLaborClass
} from "../api";
import useAppStore from "../../../store/global";
import { Spinner } from "react-bootstrap";
import { useParams, useLocation } from "react-router-dom";
import LabourTable from "./LabourTable";
import { toast, ToastContainer } from "react-toastify";

export default function LabourHome() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const restName = queryParams.get("restaurant_name");

  const [reports, setReports] = useState([]);
  const { loading, setLoading, pageSize, dateRange, reportType } =
    useAppStore();
  const [pageNum, setPageNum] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [allLaborClasses, setAllLaborClasses] = useState([]);
  const { id } = useParams();

  const handleGetLaborReport = () => {
    getLabourReport(pageNum, pageSize, id, dateRange, reportType)
      .then((data) => {
        setReports(data.labour_report);
        setTotalPages(data.totalPages);
        setLoading(false);
      })
      .catch((err) => {
        console.log("error", err);
      });
  };

  const handleGetAllLaborClasses = () => {
    getAllLaborClasses(id)
      .then((data) => {
        setAllLaborClasses(data.labor_classes);

      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleUpdateRawLabor = (labor_obj_id, labor_id) => {
    setLoading(true);
    updateRawLabor(labor_obj_id, labor_id)
      .then((data) => {
        toast.success(data.message);
        handleGetLaborReport();
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err.message);
        setLoading(false);
      });
  };

  const handleAddNewLaborClass = (posId, jobTitle, laborCategory) => {
    const body = {
      restaurant_id: id,
      pos_id: posId,
      job_title: jobTitle,
      labor_category: laborCategory,
    };
    addNewLaborClass(body)
      .then((data) => {
        toast.success(data.message);
        handleGetAllLaborClasses();
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }
  useEffect(() => {
    setLoading(true);
    handleGetAllLaborClasses();
    handleGetLaborReport();
  }, [pageNum, dateRange, reportType]);

  const handleCategoryChange = (labour_id, category) => {
    changeLabourCategory(labour_id, category)
      .then((data) => {
        toast.success(data.message);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  return (
    <>
      <NavHeader view="scrapper" />
      <ToastContainer />
      <div className="mx-2 mx-md-4" style={{ marginTop: "100px" }}>
        <BreadCrumb text={`Restaurants > ${restName} > Labour Reports`} setPageIndex = {setPageNum} />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <>
            <LabourTable
              reports={reports}
              setReports={setReports}
              handleCategoryChange={handleCategoryChange}
              allLaborClasses={allLaborClasses}
              handleUpdateRawLabor={handleUpdateRawLabor}
              handleAddNewLaborClass={handleAddNewLaborClass}
            />
            <Paginator
              pageNum={pageNum}
              setPageNum={setPageNum}
              totalPages={totalPages}
            />
          </>
        )}
      </div>
    </>
  );
}
